export var TableFilterRowType;
(function (TableFilterRowType) {
    TableFilterRowType[TableFilterRowType["RANGE"] = 0] = "RANGE";
    TableFilterRowType[TableFilterRowType["MULTI_SELECT"] = 1] = "MULTI_SELECT";
    TableFilterRowType[TableFilterRowType["SLIDE_SWITCH"] = 2] = "SLIDE_SWITCH";
    TableFilterRowType[TableFilterRowType["DATE_RANGE"] = 3] = "DATE_RANGE";
    TableFilterRowType[TableFilterRowType["MONTH_RANGE"] = 4] = "MONTH_RANGE";
    TableFilterRowType[TableFilterRowType["DECIMAL_RANGE"] = 5] = "DECIMAL_RANGE";
    TableFilterRowType[TableFilterRowType["DROPDOWN"] = 6] = "DROPDOWN";
    TableFilterRowType[TableFilterRowType["CHECKBOX_MENU"] = 7] = "CHECKBOX_MENU";
})(TableFilterRowType || (TableFilterRowType = {}));
